<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-nav-511 v-bind='{...{"brand":"\u0631\u06cc\u0646\u06af \u067e\u06cc\u0633\u062a\u0648\u0646","brandSub":"\u0644\u0648\u0627\u0632\u0645 \u06cc\u062f\u06a9\u06cc \u062a\u062e\u0635\u0635\u06cc","homeHref":{"name":"Home"},"loginText":"\u062b\u0628\u062a \u0646\u0627\u0645","loginHref":{"name":"Login"},"cartHref":{"name":"ShoppingCart"},"cartLabel":"\u0633\u0628\u062f \u062e\u0631\u06cc\u062f","menuPosition":"","navItems":[{"title":"\u0635\u0641\u062d\u0647 \u0627\u0635\u0644\u06cc","href":"\/","active":true},{"title":"\u0641\u0631\u0648\u0634\u06af\u0627\u0647","href":"\/products"},{"title":"\u062f\u0633\u062a\u0647 \u0628\u0646\u062f\u06cc \u0642\u0637\u0639\u0627\u062a","href":"\/categories"},{"title":"\u0627\u0633\u062a\u0639\u0644\u0627\u0645 \u0642\u06cc\u0645\u062a","href":"\/inquiry"},{"title":"\u062f\u0631\u0628\u0627\u0631\u0647 \u0645\u0627","href":"\/about"},{"title":"\u062a\u0645\u0627\u0633 \u0628\u0627 \u0645\u0627","href":"\/contact"}]},...{}}' :style='""' class="" >
                <template #menu>menu   </template>
                </m-nav-511></template>
                </m-div><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' />

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav511 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav511/Nav511';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mDiv,mNav511 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
